import PricingDisclaimer from 'components/Price/PricingDisclaimer/PricingDisclaimer.styled';

export default PricingDisclaimer;
